import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as pullRequests from '../../../../pull-requests'
import * as pullRequestRequirementLink from '../pull-request-requirement-link'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: pullRequestRequirementLink.RESOURCE.payload.dimension.partialId,
      partialId: pullRequestRequirementLink.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The pull request side of this link.',
    isOptional: false,
    name: 'Pull Request',
    partialId: PartialId.Standard.create('pull_request'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        pullRequests.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
